exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo {\n  top: 3px;\n  position: relative;\n  font-weight: 200;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: 5px;\n  background-image: linear-gradient(15deg, #13547a 0%, #80d0c7 100%);\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text; }\n", ""]);

// exports
